import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from './Service/config.service';

/**
 * Main bootstraped component for the application
 * 
 * @export AppComponent
 * @class AppComponent
 */
@Component({
    selector: 'app',
    template: require('./app.component.html'),
    styles: [require('./app.css')]
})
export class AppComponent implements OnInit {
    public myPayExUrl: string;

    constructor(private config: ConfigService, private translate: TranslateService) {
        //translate.setDefaultLang('sv');
        translate.use('sv');
    }

    public ngOnInit() {
        this.config.settings.subscribe((settings) => {
            this.myPayExUrl = settings.myPayExUrl;
        });
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app.component.ts
 **/